import React, { useEffect, useState, useMemo } from 'react'
import LazyLoad from '../../../PreflopCharts/components/LazyLoad'
import { NUMBER_OF_HANDS } from '../../mock'

import StandartIcon from '../../../../icons/standart.svg'
import PremiumIcon from '../../../../icons/premium.svg'
import { getMediaUrl } from '../../../../utils/utils'

export const Actions = ({
  actions,
  selectedFilters,
  rewriteSelectedFiltersAction,
  getFolderHandler,
  type,
  config,
  userAccess,
  showAccessPopup,
  sendChartOptionSelectToAnalytics
}) => {
  const [accessConfig, setAccessConfig] = useState({
    showChips: false,
    hasAccess: false,
  })
  const { icmRestrictions } = config

  const onPress = (item) => {
    if (!accessConfig.hasAccess) {
      const requiredAccess = getRequiredAccess()
      showAccessPopup(requiredAccess)
      return
    }

    sendChartOptionSelectToAnalytics(item.name)

    rewriteSelectedFiltersAction({
      key: 'action',
      value: {
        ...item,
        onClick: () => {
          getFolderHandler(item.name)
        },
      },
    })
    getFolderHandler(item.name)
  }

  const getRequiredAccess = () => {
    const { chartType } = selectedFilters
    if (!type || !chartType || !icmRestrictions) return 'free'

    const chartTypeValue = NUMBER_OF_HANDS[chartType]
    const requiredAccess = icmRestrictions[chartTypeValue][type]
    return requiredAccess
  }

  const checkAccess = () => {
    let showChips = false
    let hasAccess = true
    if (userAccess === 'guest') {
      hasAccess = false
    } else if (userAccess === 'pcp') {
      showChips = false
      hasAccess = true
    } else {
      const requiredAccess = getRequiredAccess()
      if (requiredAccess === 'pcp') {
        showChips = 'pcp'
        hasAccess = false
      } else if (requiredAccess === 'pc') {
        hasAccess = userAccess === 'pc'
        showChips = hasAccess ? false : 'pc'
      }
    }
    setAccessConfig({ showChips, hasAccess })
  }

  useEffect(() => {
    checkAccess()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, selectedFilters, icmRestrictions])

  const renderAccessChips = useMemo(() => {
    const { showChips } = accessConfig
    if (!showChips) return null
    if (showChips === 'pcp') {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            position: 'absolute',
            top: '-7px',
            right: '-3px',
            zIndex: '10',
          }}
        >
          <img
            alt=""
            style={{ widht: '14px', height: '14px' }}
            src={getMediaUrl(PremiumIcon)}
          />
        </div>
      )
    }
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          position: 'absolute',
          top: '-7px',
          right: '-3px',
          zIndex: '10',
        }}
      >
        <img
          alt=""
          style={{ widht: '14px', height: '14px', marginRight: '-3px' }}
          src={getMediaUrl(StandartIcon)}
        />
        <img
          alt=""
          style={{ widht: '14px', height: '14px' }}
          src={getMediaUrl(PremiumIcon)}
        />
      </div>
    )
  }, [accessConfig])
  return (
    <div
      style={{
        fontSize: '16px',
        fontFamily: ' Roboto, sans-serif',
        width: '100%',
      }}
      className="ICMCharts__label"
    >
      <p>Action</p>
      <div className="PreflopCharts__options-row">
        {!actions?.length ? (
          <LazyLoad size={6} />
        ) : (
          actions.map((action, idx) => {
            const { name, chart_type: chartType } = action
            if (chartType !== type) return null
            const isSelected = name === selectedFilters?.action?.name

            return (
              <div
                key={action.name}
                className="ICMCharts__button"
                onClick={() => onPress(action)}
                style={{
                  borderWidth: isSelected ? '2px' : 0,
                  position: 'relative',
                }}
              >
                <div
                  className="ICMCharts__button-label"
                  style={{
                    color: isSelected ? '#0085FF' : 'black',
                  }}
                >
                  {name}
                </div>
                {renderAccessChips}
              </div>
            )
          })
        )}
      </div>
    </div>
  )
}
